import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-customer-visit-details',
  templateUrl: './customer-visit-details.component.html',
  styleUrls: ['./customer-visit-details.component.css']
})
export class CustomerVisitDetailsComponent implements OnInit {

  constructor(private customerService:ServiceService,private route: ActivatedRoute, private router: Router) { }
  
  output:any=[]; //---store get() result--------
  customerId='';
  //getUrl='http://192.241.151.66:5000/viewVisit';
  name=""
  center!: google.maps.LatLngLiteral;
  markers:any=[]
  zoom = 12;
  //-------date formating-------------
  today: Date = new Date();
  pipe = new DatePipe('en-US');
  todayWithPipe:any= null;

  addMarker() {
    this.markers.push({
      position: {
        lat: this.center.lat,
        lng: this.center.lng,
      },
      label: {
        color: 'red',
        text: 'Customer visit' + (this.markers.length + 1),
      },
      title: 'Customer visit' + (this.markers.length + 1),
      options: { animation: google.maps.Animation.BOUNCE },
    });
    
  }
  

  ngOnInit(): void {

    //---call function in service for customer Id------
    this.customerId=this.customerService.getCustomerId()
    console.log("customer id=",this.customerId)

   //-------api get()calling-------------
   this.customerService.CustomerVisitDetals('/'+this.customerId).subscribe((res)=>{
     this.output=res.data
     this.name=this.output[0].customer_name
     console.log("customer details =",this.output)
      //-------date formating----------------------
    this.todayWithPipe = this.pipe.transform(this.output[0].date_time, 'MMM d, y, h:mm:ss a');
    
//------------------set current center----------------------------
  this.center = {
    lat: this.output[0].visit_latitude,
    lng: this.output[0].visit_longitude,
  };
 this.addMarker();
//----------end-------------------------------------------------------
   })
   
  }

}
